import {
  IconLaurelLeft,
  IconLaurelRight,
  Tag,
  TagColor,
  TagRounding,
  TagSize,
  Tooltip,
} from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

export const CustomerFavoriteTag: FC<{ categoryName: string }> = ({
  categoryName,
}) => {
  return (
    <Tooltip content={`Top 10% of coaches in ${categoryName} on Leland`}>
      <Tag
        largeIcons={true}
        CustomLeftIcon={({ iconClassName }) => (
          <IconLaurelLeft
            className={iconClassName + ' text-leland-primary -mr-1.5'}
          />
        )}
        CustomRightIcon={({ iconClassName }) => (
          <IconLaurelRight
            className={iconClassName + ' text-leland-primary !-m-0'}
          />
        )}
        size={TagSize.XS}
        text="Customer favorite"
        tagColor={TagColor.PRIMARY}
        rounding={TagRounding.SM}
      />
    </Tooltip>
  );
};
